import Members from '@/views/Members'

export default [
  {
    path: '/members',
    name: 'members',
    component: Members
  }
]
